import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { UserRole } from '@promtver/contracts';
import { StateBlock } from '@promtver/ui-kit';

import { ru } from '../i18n/ru';
import { useAuth } from './AuthProvider';
import { isAwaitingApproval } from './session';

/**
 * Доступ к панели — только для роли «представитель предприятия»
 * (ТЗ §3.1, Приложение В). Права на объекты проверяет сервер.
 *
 * Представитель без привязанного предприятия — не «чужой» пользователь:
 * его заявка принята, но объект ещё не назначен. Таких переводим на экран
 * ожидания подтверждения, иначе любой запрос /partner/* вернёт 403.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, isRestored, logout } = useAuth();
  const location = useLocation();

  if (!isRestored) {
    return null;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (isAwaitingApproval(user)) {
    return <Navigate to="/pending" replace />;
  }

  if (user.role !== UserRole.ObjectModerator) {
    return (
      <div className="mx-auto max-w-panel p-4">
        <StateBlock
          kind="forbidden"
          title={ru.login.errorForbidden}
          actionLabel={ru.nav.logout}
          onAction={logout}
        />
      </div>
    );
  }

  return <>{children}</>;
}
